import type { SVGProps } from 'react';

const LinkedReadingCommentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.0417 1.14583C16.6745 1.14583 17.1875 1.65884 17.1875 2.29167V11.4583C17.1875 12.0912 16.6745 12.6042 16.0417 12.6042H5.05795C4.45016 12.6042 3.86727 12.8456 3.4375 13.2754L1.14583 15.567V2.29167C1.14583 1.65884 1.65884 1.14583 2.29167 1.14583H16.0417ZM2.29167 0C1.02601 0 0 1.02601 0 2.29167V16.9502C0 17.4606 0.617112 17.7162 0.978029 17.3553L4.24773 14.0856C4.46261 13.8707 4.75406 13.75 5.05795 13.75H16.0417C17.3073 13.75 18.3333 12.724 18.3333 11.4583V2.29167C18.3333 1.02601 17.3073 0 16.0417 0H2.29167Z"
      fill="currentColor"
    />
    <path
      d="M3.4375 4.01042C3.4375 3.694 3.694 3.4375 4.01042 3.4375H14.3229C14.6393 3.4375 14.8958 3.694 14.8958 4.01042C14.8958 4.32683 14.6393 4.58333 14.3229 4.58333H4.01042C3.694 4.58333 3.4375 4.32683 3.4375 4.01042ZM3.4375 6.875C3.4375 6.55859 3.694 6.30208 4.01042 6.30208H14.3229C14.6393 6.30208 14.8958 6.55859 14.8958 6.875C14.8958 7.19141 14.6393 7.44792 14.3229 7.44792H4.01042C3.694 7.44792 3.4375 7.19141 3.4375 6.875ZM3.4375 9.73958C3.4375 9.42317 3.694 9.16667 4.01042 9.16667H9.73958C10.056 9.16667 10.3125 9.42317 10.3125 9.73958C10.3125 10.056 10.056 10.3125 9.73958 10.3125H4.01042C3.694 10.3125 3.4375 10.056 3.4375 9.73958Z"
      fill="currentColor"
    />
  </svg>
);

export default LinkedReadingCommentIcon;
